/**
 * Maps a score (0–1000) to a color on a blue → yellow → red gradient.
 * 0 = blue, 500 = yellow, 1000 = red.
 */
export function getScoreColor(score: number): string {
  const clamped = Math.max(0, Math.min(1000, score));

  // Blue  (0):   rgb(59, 130, 246)
  // Yellow(500): rgb(251, 191, 36)
  // Red   (1000):rgb(239, 68, 68)

  if (clamped <= 500) {
    const t = clamped / 500;
    const r = Math.round(59 + (251 - 59) * t);
    const g = Math.round(130 + (191 - 130) * t);
    const b = Math.round(246 + (36 - 246) * t);
    return `rgb(${r}, ${g}, ${b})`;
  }

  const t = (clamped - 500) / 500;
  const r = Math.round(251 + (239 - 251) * t);
  const g = Math.round(191 + (68 - 191) * t);
  const b = Math.round(36 + (68 - 36) * t);
  return `rgb(${r}, ${g}, ${b})`;
}

/**
 * Returns a text color (white or dark) for readability on the score gradient.
 */
export function getScoreTextColor(score: number): string {
  const clamped = Math.max(0, Math.min(1000, score));
  if (clamped < 300 || clamped > 800) {
    return '#ffffff';
  }
  return '#1a1a1a';
}

/** CSS gradient string for the score scale bar */
export const SCORE_GRADIENT =
  'linear-gradient(to right, rgb(59, 130, 246), rgb(251, 191, 36), rgb(239, 68, 68))';
